<template>
  <main class="flex-item">
    <div class="card">
      <header class="card-header page-title">
        <p class="card-header-title is-size-4"><span class="material-icons is-size-4">lock</span>パスワード変更</p>
      </header>
      <div class="card-content">
        <div class="field">
          <p class="block mt-3 mb-5">パスワードの変更が完了いたしました。</p>
        </div>
        <footer class="card-footer">
          <div class="card-footer-item">
            <span>
              <router-link class="card-footer-item button is-primary is-normal is-medium" :to="{ name: 'Top' }">TOPに戻る</router-link>
            </span>
          </div>
        </footer>
      </div>
    </div>
  </main>
</template>
